import styled from "styled-components";

export const LoadingLayout = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
`;

export const LoadingText = styled.p`
  font-size: 2rem;
  font-weight: bold;
  color: #4b3bff;
`;
